import { ReactElement } from 'react'

import Image from 'next/image'
import Link from 'next/link'

import clsx from 'clsx'

import { SETTINGS_GENERAL } from '@/config/settings.general'
import { useReachGoal } from '@/hooks/useReachGoal'

import appStore from './icons/app-store.svg'
import googlePlay from './icons/google-play.svg'
import cloudM from './images/cloud-m.webp'
import cloudS from './images/cloud-s.webp'
import iphone from './images/phone.webp'
import styles from './styles.module.scss'

const clouds = [
    { image: cloudM, class: clsx(styles.images__item, styles.images__m) },
    { image: cloudS, class: clsx(styles.images__item, styles.images__s) },
]

interface Props {
    onOpenWaitListModal: () => void
}

export default function Banner({ onOpenWaitListModal }: Props): ReactElement {
    const reachGoal = useReachGoal()

    return (
        <section className={styles.wrapper}>
            <div className={styles.inner}>
                <div className={styles.content}>
                    <div className={styles.clouds}>
                        {clouds.map((cloud, index) => (
                            <Image
                                key={`cloud-${index}`}
                                src={cloud.image}
                                alt={''}
                                className={cloud.class}
                            />
                        ))}
                        <Image
                            src={iphone}
                            alt={'BukaGo'}
                            className={styles.images__phone}
                        />
                    </div>
                    <div className={styles.text}>
                        <h2 className={styles.text__title}>
                            {'Бейсик - контроль экранного\nвремени ребенка'}
                        </h2>
                        <p className={styles.text__description}>
                            {
                                'Прививайте правильные привычки, обучайте и контролируйте геолокацию и время за гаджетами.'
                            }
                        </p>
                        <div className={styles.text__buttons}>
                            <Link
                                href={SETTINGS_GENERAL.SITE_URL}
                                onClick={() =>
                                    reachGoal({
                                        goalName: 'went-to-the-main-site',
                                    })
                                }
                            >
                                {'Подробнее о приложении'}
                            </Link>
                        </div>
                    </div>
                    <div className={styles.icons}>
                        <button onClick={onOpenWaitListModal}>
                            <Image src={appStore} alt={'Скачать в App Store'} />
                        </button>
                        <button onClick={onOpenWaitListModal}>
                            <Image
                                src={googlePlay}
                                alt={'Скачать в Google Play'}
                            />
                        </button>
                    </div>
                </div>
            </div>
        </section>
    )
}
